export default __webpack_public_path__ + "static/media/repeat.c1fa61af.svg";